import resize from './resize'

const install = function (Vue) {
  Vue.directive('resize', resize)
}

if (window.Vue) {
  window.resize = resize
  Vue.use(install)
}

resize.install = install
export default resize
